import { OptionType } from '../types/basket-types';

export const MapRequirementOptions = (options?: string[] | OptionType[]) => {
  if (!options) return undefined;

  return (options || []).map((x) => {
    if (typeof x === 'string') {
      return { value: x, label: x };
    }
    return x;
  });
};
